(function () {
  'use strict';

  function initLookbook(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lookbook-slide]'));
    var navButtons = Array.prototype.slice.call(root.querySelectorAll('[data-lookbook-nav]'));
    var prevBtn = root.querySelector('[data-lookbook-prev]');
    var nextBtn = root.querySelector('[data-lookbook-next]');
    var currentLabels = root.querySelectorAll('[data-current-slide]');
    var total = slides.length;
    if (total === 0) return;

    var current = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6000;
    var timer = null;

    function pad(n) {
      return String(n + 1).padStart(2, '0');
    }

    function goTo(index) {
      index = ((index % total) + total) % total;
      if (index === current) return;

      slides[current].classList.remove('is-active');
      slides[index].classList.add('is-active');

      navButtons.forEach(function (btn) {
        var btnIndex = parseInt(btn.getAttribute('data-index'), 10);
        var isMatch = btnIndex === index;
        btn.classList.toggle('is-active', isMatch);
        btn.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      });

      currentLabels.forEach(function (el) {
        el.textContent = pad(index);
      });

      current = index;
      restartAutoplay();
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay || total <= 1) return;
      stopAutoplay();
      timer = setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function restartAutoplay() {
      if (autoplay) startAutoplay();
    }

    navButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.getAttribute('data-index'), 10);
        goTo(index);
      });
    });

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    // Pause autoplay on hover/focus (desktop)
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', restartAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', restartAutoplay);

    // Swipe support (mobile)
    var touchStartX = 0;
    var touchEndX = 0;
    var viewport = root.querySelector('.lookbook__viewport');

    if (viewport) {
      viewport.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        function (e) {
          touchEndX = e.changedTouches[0].screenX;
          var delta = touchEndX - touchStartX;
          if (Math.abs(delta) > 40) {
            if (delta < 0) {
              next();
            } else {
              prev();
            }
          }
        },
        { passive: true }
      );
    }

    // Keyboard navigation when section is focused
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') next();
      if (e.key === 'ArrowLeft') prev();
    });

    startAutoplay();

    // ---- Product drawer ----
    var drawer = root.querySelector('[data-product-drawer]');
    if (drawer) {
      var drawerItems = Array.prototype.slice.call(drawer.querySelectorAll('[data-product-id]'));
      var lastFocused = null;

      function openDrawerWithProductIds(productIds, slideIndex) {
        var anyVisible = false;
        drawerItems.forEach(function (item) {
          var id = item.getAttribute('data-product-id');
          var itemSlide = item.getAttribute('data-slide-index');
          var show;
          if (productIds && productIds.length) {
            show = productIds.indexOf(id) !== -1;
          } else {
            show = itemSlide === String(slideIndex);
          }
          item.classList.toggle('is-visible', show);
          if (show) anyVisible = true;
        });

        var list = drawer.querySelector('[data-drawer-list]');
        var existingEmpty = list.querySelector('.lookbook__drawer-empty');
        if (!anyVisible) {
          if (!existingEmpty) {
            var empty = document.createElement('p');
            empty.className = 'lookbook__drawer-empty';
            empty.textContent = 'No products available.';
            list.appendChild(empty);
          }
        } else if (existingEmpty) {
          existingEmpty.remove();
        }

        lastFocused = document.activeElement;
        drawer.setAttribute('data-open', '');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var closeBtn = drawer.querySelector('.lookbook__drawer-close');
        if (closeBtn) closeBtn.focus();
      }

      function closeDrawer() {
        drawer.removeAttribute('data-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (lastFocused) lastFocused.focus();
      }

      drawer.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', closeDrawer);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.hasAttribute('data-open')) {
          closeDrawer();
        }
      });

      // "View Products" buttons — show only this slide's products
      root.querySelectorAll('[data-view-products-trigger]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var slideEl = btn.closest('[data-lookbook-slide]');
          var slideIndex = slideEl ? slideEl.getAttribute('data-index') : null;
          var idsAttr = btn.getAttribute('data-products') || '';
          var ids = idsAttr.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
          openDrawerWithProductIds(ids, slideIndex);
        });
      });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-lookbook]');
    roots.forEach(initLookbook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when section is added/edited in theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lookbook]');
    if (root) initLookbook(root);
  });
})();
